/* Styles for this component are in styles/Sidebar.scss */
import React, { Component } from "react";

/* We take 100% width, 100% height of what's offered; our parent constraints our size */
class Sidebar extends Component {
    render() {
        return (
            <div className="Sidebar">
                {this.props.children}
            </div>
        );
    }
}

export default Sidebar;
